module.exports = __webpack_public_path__ + "img/quienes-cel.e627d49f.png";